import { Modal, Form } from "react-bootstrap";
import { useState } from "react";
import ButtonLoader from "../../sharedComponent/ButtonLoader";

export default function BankDetails() {

    const [isUpdateBankDetails, setIsUpdateBankDetails] = useState(false)

    const [validated, setValidated] = useState(false)

    const [btnLoader, setBtnLoader] = useState(false)

    const updateBankDetails = (e) => {
        e.preventDefault();
        const form = e.currentTarget;
        if (form.checkValidity() === false) {
            setValidated(true);
            e.preventDefault();
            e.stopPropagation();
            return

        }



    }

    const handleClose = () => {

        setIsUpdateBankDetails(false);
        setValidated(false);

    }

    return (
        <>
            <div className="">
                <div className="personal-heading-main">
                    <h3>Bank Details</h3>

                    <button
                        style={{
                            backgroundColor: "transparent",
                            border: "none",
                            cursor: "pointer",
                            fontSize: "18px",
                        }}
                    >
                        <i
                            class="fa-solid fa-pen-to-square"
                            onClick={() => {
                                setIsUpdateBankDetails(true)
                            }}
                        ></i>
                    </button>
                </div>
                <div className="lineSeperate2"></div>
                <div className="row p-0">
                    <div className="col-md-4 mt-2">
                        <label htmlFor=""> Full Name of Recipient</label>
                        <p className="mb-3">
                            Amir Khan
                        </p>
                    </div>
                    <div className="col-md-4 mt-2">
                        <label htmlFor="">Account Number</label>
                        <p className="mb-3">
                            1234567890
                        </p>
                    </div>
                    <div className="col-md-4 mt-2">
                        <label htmlFor="">IFSC Code</label>
                        <p className="mb-3">
                            IFC-011
                        </p>
                    </div>
                    <div className="col-md-4 mt-2">
                        <label htmlFor="">Bank Name</label>
                        <p className="mb-3">
                            HDFC Bank
                        </p>
                    </div>
                    <div className="col-md-4 mt-2">
                        <label htmlFor="">Bank Branch Location</label>
                        <p className="mb-3">
                            Sillod
                        </p>
                    </div>
                </div>
            </div>
            <Modal
                show={isUpdateBankDetails}
                onHide={handleClose}
                size="lg"

                aria-labelledby="modal-90w"
                className="add-task-modal-main"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Update Bank Details</Modal.Title>
                </Modal.Header>
                <div className="lineSeperate"></div>
                <Form noValidate validated={validated} onSubmit={updateBankDetails}>
                    <Modal.Body>

                        <div className="row p-0">
                            <div className="col-md-4">
                                <label htmlFor="" className="mb-2 text-grey">
                                    Full Name of Recipient
                                    <span className="text-danger fw-bolder">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control tasKCategory1 mb-2"

                                    required
                                />
                                <div className="invalid-feedback">Enter Full Name of Recipient</div>
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="" className="mb-2 text-grey">
                                    Account Number
                                    <span className="text-danger fw-bolder">*</span>
                                </label>
                                <input
                                    type="number"
                                    className="form-control tasKCategory1 mb-2"

                                    required
                                />
                                <div className="invalid-feedback">Enter  Account Number</div>
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="" className="mb-2 text-grey">
                                    IFSC Code
                                    <span className="text-danger fw-bolder">*</span>
                                </label>
                                <input
                                    type="number"
                                    className="form-control tasKCategory1 mb-2"

                                    required
                                />
                                <div className="invalid-feedback">Enter IFSC Code</div>
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="" className="mb-2 text-grey">
                                    Bank Name
                                    <span className="text-danger fw-bolder">*</span>
                                </label>
                                <input
                                    type="number"
                                    className="form-control tasKCategory1 mb-2"

                                    required
                                />
                                <div className="invalid-feedback">Enter Bank Name</div>
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="" className="mb-2 text-grey">
                                    Bank Branch Location
                                    <span className="text-danger fw-bolder">*</span>
                                </label>
                                <input
                                    type="number"
                                    className="form-control tasKCategory1 mb-2"

                                    required
                                />
                                <div className="invalid-feedback">Enter Bank Branch Location</div>
                            </div>
                        </div>

                    </Modal.Body>
                    <div className="lineSeperate"></div>
                    <div className="d-flex justify-content-end align-items-center mainBtnsSub">
                        <button
                            className="btn-width cancelBtn mx-3"
                            type="button"
                        // onClick={() => {
                        //     handleClose();
                        //     setValidated(false);
                        // }}
                        >
                            Cancel
                        </button>
                        <button className="btn-width saveBtn" type="submit">
                            {btnLoader ? <ButtonLoader /> : "Update"}
                        </button>
                    </div>
                </Form>
            </Modal >
        </>
    )

}

